export const BASE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_API_URL;

export const EMPLOYEE_AVAILABILITY_URL = process.env.REACT_APP_DAVINCI_EMPLOYEE_AVAILABILITY_URL;

export const KERNEL_URL = process.env.REACT_APP_DAVINCI_FRONTEND_KERNEL_URL;

export const CORE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_CORE_URL;

export const DELIVERY_URL = process.env.REACT_APP_DAVINCI_FRONTEND_DELIVERY_URL;

export const FINANCE_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_FINANCE_SERVICE_URL;

export const SM_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_SM_URL;

export const PRIVILEGED_ACCESS_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_PRIVILEGED_ACCESS_SERVICE_URL;

export const SCS_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_SCS_URL;

export const ST_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_ST_URL;

export const PPLM_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_PPLM_URL;

export const RECRUITING_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_RECRUITING_URL;

export const SSO_AUTH_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_SSO_AUTH_SERVICE_URL;

export const DOCUMENT_SERVICE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_DOCUMENT_URL;

export const DOCUMENT_PREVIEW_URL = process.env.REACT_APP_DAVINCI_FRONTEND_DOCUMENT_PREVIEW_URL;

export const FILE_DIFFERENCE_URL = process.env.REACT_APP_DAVINCI_FRONTEND_FILE_DIFFERENCE_URL;

// One per SDLC account: each owns the API that wakes it, so there is no single base
// URL for the sleep console to post to.
export const WAKE_API_DAVINCI_URL = process.env.REACT_APP_DAVINCI_FRONTEND_WAKE_API_DAVINCI_URL;

export const WAKE_API_JARVIS_URL = process.env.REACT_APP_DAVINCI_FRONTEND_WAKE_API_JARVIS_URL;
